// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__vyJDo","right":"styles_right__16HPd"};